import React from 'react';
import { useLocation } from 'react-router-dom';
import NavMenu from '../NavMenu';
import './Layout.css';

const Layout = ({ children, userRole }) => {
    const location = useLocation();

    // Hide the sidebar layout on the login page entirely
    if (location.pathname === '/login') {
        return (
            <div className="concept3-page-content" style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {children}
            </div>
        );
    }

    return (
        <div className="concept3-layout">
            <aside className="concept3-sidebar d-none d-md-block">
                <NavMenu userRole={userRole} inSidebar={true} />
            </aside>
            <main className="concept3-main-content">
                {/* Mobile top-nav or bottom-nav could go here if needed, for now NavMenu handles it */}
                <div className="d-block d-md-none mobile-nav-wrapper">
                    <NavMenu userRole={userRole} inSidebar={false} />
                </div>
                <div className="concept3-page-content">
                    {children}
                </div>
            </main>
        </div>
    );
};

export default Layout;
